<div class="c-portlet__content pos-relative" style="height: 850px">
	<div>
		<div class="map-wrapper">
			<div id="map" style="width: 100%; height: 775px"></div>
			<div id="info" class="info"></div>
			<div id="geofence-disclaimer" class="geofence-disclaimer">
				<div class="geofence-disclaimer-section">
					<img class="geofence-disclaimer-img" src="../../../../../../assets/images/info-circle.png" />
					<span class="geofence-disclaimer-text"
						>Geofence/geo recency points may not display due to category-specific privacy restrictions in a selected
						campaign.</span
					>
				</div>
			</div>
		</div>

		<!-- LIft Detail Container-->
		<div class="map-region-lift-detail-container">
			<!-- Show Lift -->
			<div class="map-region-lift">
				<div class="lift-stats">
					<div>Lift</div>
					<div class="lift-value">
						<span
							*ngIf="polygonLayerDetails.showLift && polygonLayerDetails.avgLift"
							class="map-region-dmographic-value"
							>{{ polygonLayerDetails.avgLift }}x</span
						>
						<span
							*ngIf="!polygonLayerDetails.showLift || !polygonLayerDetails.avgLift"
							class="map-region-dmographic-value"
							>n/a</span
						>
					</div>
				</div>
			</div>

			<div class="map-region-lift-stats">
				<!-- Show Average Home Value -->
				<div class="map-region-dmographic-container margin-20pt">
					<div class="lift-stats">
						<div class="lift-stats-header">
							<i class="fa fa-map-marker" aria-hidden="true" style="color: #2c3e50; font-size: 1.2em"></i>
							Postal Code
						</div>
						<div class="lift-stats-value">
							<span *ngIf="polygonLayerDetails.zip" class="map-region-dmographic-value">{{
								polygonLayerDetails.zip
							}}</span>
							<span *ngIf="!polygonLayerDetails.zip" class="map-region-dmographic-value">n/a</span>
						</div>
					</div>
				</div>

				<!-- Show Average Home Value -->
				<div class="map-region-dmographic-container margin-20pt">
					<div class="lift-stats">
						<div class="lift-stats-header">
							<i class="fa fa-home" aria-hidden="true" style="color: #3498db; font-size: 1.2em"></i>
							Home Value
						</div>
						<div class="lift-stats-value">
							<span
								*ngIf="polygonLayerDetails.showLift && polygonLayerDetails.avgHomeValue"
								class="map-region-dmographic-value"
								>${{ polygonLayerDetails.avgHomeValue | formatNumber }}</span
							>
							<span
								*ngIf="!polygonLayerDetails.showLift || !polygonLayerDetails.avgHomeValue"
								class="map-region-dmographic-value"
								>n/a</span
							>
						</div>
					</div>
				</div>

				<!-- Show Average Income -->
				<div class="map-region-dmographic-container">
					<div class="lift-stats">
						<div class="lift-stats-header">
							<i class="fa fa-usd" aria-hidden="true" style="color: #226b00; font-size: 1.2em"></i>
							Income
						</div>
						<div class="lift-stats-value">
							<span
								*ngIf="!polygonLayerDetails.showLift || polygonLayerDetails.avgIncome"
								class="map-region-dmographic-value"
								>${{ polygonLayerDetails.avgIncome | formatNumber }}</span
							>
							<span *ngIf="!polygonLayerDetails.avgIncome" class="map-region-dmographic-value">n/a</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- LIft Detail Container-->

		<div class="zoom-options-container">
			<div class="zoom-icon zoom-in" (click)="zoomIn()"></div>
			<div class="zoom-icon zoom-out" style="border-top: 0px" (click)="zoomOut()"></div>
		</div>

		<!-- Geofence legends Container -->
		<div class="geoCenters-info" *ngIf="showGeofenceLegends">
			<div class="geoCenters-div geofence-div">
				<div class="geo-dot"></div>
				<div class="geo-values">GeoFence</div>
			</div>
			<div class="geoCenters-div">
				<div class="recency-dot"></div>
				<div class="geo-values">Retargeting</div>
			</div>
		</div>

		<div class="no-data-container" style="height: 580px" *ngIf="noData">
			<div class="map-no-data">No Data to Display</div>
		</div>
	</div>
</div>
